import React, { useState, useContext, useEffect } from "react";
import { useParams, Link, useLocation, useNavigate } from "react-router-dom";

import SuiButton from "components/SuiButton";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import InstagramIcon from "@mui/icons-material/Instagram";
import StoreIcon from "@mui/icons-material/Store";
import MessageIcon from "@mui/icons-material/Message";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import EngineeringIcon from "@mui/icons-material/Engineering";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import EditIcon from "@mui/icons-material/Edit";

// Soft UI Dashboard PRO React components
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiBadge from "components/SuiBadge";
import SuiInput from "components/SuiInput";

import Avatar from "@mui/material/Avatar";

import { StoreContext } from "context/store";
import { AccountContext } from "context/account";

import api from "services/api";
import storeApi from "services/store-api";

import qs from "query-string";
import toast from "react-hot-toast";

import ReadMore from "components/UpStyled/ReadMore";

import DraggableDialog from "components/UpStyled/DraggableDialog";
import ChatRoom from "pages/messages/chatroom";

import { addProtocol, formatAddress } from "utils/helper";
import Tooltip from "@mui/material/Tooltip";
import ImageCardWrapper from "components/UpStyled/ImageCardWrapper";
import { MANUFACTURER_SERVICES, accountTypeOptions } from "utils/data";

import moment from "moment";
import FollowButton2 from "pages/de/posts/components/FollowButton2";

const ProfileCardMobile = ({ userData = {}, storeData = {}, postList = [], counts = {} }) => {
  const [chatVisible, setChatVisible] = useState(false);
  const [currentRoom, setCurrentRoom] = useState(new Map());

  const { store, updateStore } = useContext(StoreContext);
  const account = useContext(AccountContext);

  const params = useParams();
  const handle = params?.handle;

  const address = formatAddress(storeData?.metadata?.address, true);

  const handleOpenChat = async () => {
    if (userData?.id) {
      await retrieveChats(userData?.id);
      setChatVisible(true);
    }
  };

  const retrieveChats = async (userId) => {
    if (!userId) {
      return;
    }
    try {
      const { data } = await api.chatroom.addChatRoom({
        userids: [userId],
      });
      setCurrentRoom(data);
    } catch (err) {
      console.log(err);
    }
  };

  const accountType = userData?.metadata?.account_role || userData.account_type;
  const accountRole = accountTypeOptions.find((x) => x.value == accountType);

  const allPosttViews = postList.reduce((acc, b) => acc + b.page_view, 0);
  const allPostLikes = postList.reduce((acc, b) => acc + b.like_amount, 0);
  const instagram_link = storeData?.metadata?.instagram_link;
  const facebook_link = storeData?.metadata?.facebook_link;
  const twitter_link = storeData?.metadata?.twitter_link;

  const isOwner = account?.id && account.id == userData?.id;

  return (
    <SuiBox>
      <SuiBox
        sx={{
          height: "100%",
          flexGrow: 0,
        }}
      >
        <SuiBox
          sx={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mt: -6,
          }}
        >
          <Avatar
            src={storeData?.metadata?.avatar}
            sx={{
              width: 106,
              height: 106,
              cursor: handle ? "cursor" : "pointer",
              zIndex: 3,
              border: "solid 6px #ffffff",
            }}
          />
        </SuiBox>

        <Card sx={{ width: "100%", borderRadius: 0, mt: -7, pt: 7 }}>
          <SuiBox sx={{ width: "100%", textAlign: "center", px: 3, py: 1 }}>
            <SuiTypography variant="h5">{storeData.name}</SuiTypography>
            <SuiTypography variant="body1" color="text">
              <SuiBadge
                badgeContent={
                  <SuiTypography
                    variant="body2"
                    fontWeight="bold"
                    color="white"
                    sx={{ lineHeight: 1, px: 0.5, py: 0.2 }}
                  >
                    {accountRole ? accountRole.label : "Designer"}
                  </SuiTypography>
                }
                size="xxs"
                varinat="contained"
              />
            </SuiTypography>
            {/* <SuiTypography variant="body1" color="text">
                {storeData.name}
              </SuiTypography> */}

            {address ? (
              <SuiBox display="flex" my={0.5} justifyContent="space-between" alignItems="center">
                <SuiTypography
                  variant="body1"
                  fontWeight="regular"
                  color="text"
                  display="flex"
                  alignItems="center"
                >
                  <LocationOnIcon />
                  {address}
                </SuiTypography>
              </SuiBox>
            ) : (
              <br />
            )}
            <Grid container spacing={2} sx={{ my: 2 }}>
              <Grid item xs={12} sm={6}>
                <FollowButton2
                  circular
                  variant="contained"
                  size="medium"
                  sx={{ width: "100%" }}
                  user={storeData}
                  disabled={isOwner}
                >
                  Follow
                </FollowButton2>
              </Grid>
              <Grid item xs={12} sm={6}>
                <SuiButton
                  color="secondary"
                  variant="contained"
                  circular
                  size="medium"
                  sx={{ width: "100%" }}
                  onClick={handleOpenChat}
                  disabled={isOwner || !account.id}
                >
                  Message
                </SuiButton>
              </Grid>
            </Grid>

            <SuiBox sx={{ border: "solid 2px #e3e3e3", width: "100%", p: 0.5, my: 1 }}>
              <SuiBox display="flex" justifyContent="space-between" my={0.5} px={1}>
                <SuiTypography variant="body1" fontWeight="bold" color="dark">
                  Hire Me
                </SuiTypography>
                <SuiTypography variant="body1" fontWeight="bold" color="dark">
                  <ArrowForwardIosIcon />
                </SuiTypography>
              </SuiBox>
              <SuiBox mx={1.5}>
                <SuiBox sx={{ border: "solid 1px #e3e3e3", width: "100%", height: 1 }} />
              </SuiBox>
              <SuiBox display="flex" gap={0.5} my={1} mx={1}>
                <EngineeringIcon sx={{ width: 32, height: 32 }} color="secondary" />
                <SuiTypography variant="body1" color="text" lineHeight={1.1} sx={{ ml: 1 }}>
                  Coming soon
                </SuiTypography>
              </SuiBox>
            </SuiBox>
            <SuiBox>
              <SuiBox display="flex" justifyContent="space-between">
                <SuiTypography variant="body1" color="dark" lineHeight={1.6}>
                  Post Views
                </SuiTypography>
                <SuiTypography variant="body1" color="dark" lineHeight={1.6}>
                  {allPosttViews}
                </SuiTypography>
              </SuiBox>
              <SuiBox display="flex" justifyContent="space-between">
                <SuiTypography variant="body1" color="dark" lineHeight={1.6}>
                  Total Likes
                </SuiTypography>
                <SuiTypography variant="body1" color="dark" lineHeight={1.6}>
                  {allPostLikes}
                </SuiTypography>
              </SuiBox>
              <SuiBox display="flex" justifyContent="space-between">
                <SuiTypography variant="body1" color="dark" lineHeight={1.6}>
                  Following
                </SuiTypography>
                <SuiTypography variant="body1" color="dark" lineHeight={1.6}>
                  {counts.followingcount}
                </SuiTypography>
              </SuiBox>
              <SuiBox display="flex" justifyContent="space-between">
                <SuiTypography variant="body1" color="dark" lineHeight={1.6}>
                  Followers
                </SuiTypography>
                <SuiTypography variant="body1" color="dark" lineHeight={1.6}>
                  {counts.followerscount}
                </SuiTypography>
              </SuiBox>
            </SuiBox>
            {instagram_link || facebook_link || twitter_link ? (
              <SuiBox mt={3} mb={2}>
                <SuiTypography
                  variant="body1"
                  color="text"
                  fontWeight="bold"
                  lineHeight={1.1}
                  textTransform="uppercase"
                  textAlign="start"
                >
                  follow me on social
                </SuiTypography>
                <SuiBox display="flex" alignItems="center">
                  {instagram_link && (
                    <a
                      target={"_blank"}
                      href={addProtocol(instagram_link)}
                      className="text-gray-800 mr-2"
                    >
                      <InstagramIcon fontSize="small" />
                    </a>
                  )}
                  {facebook_link && (
                    <a
                      target={"_blank"}
                      href={addProtocol(facebook_link)}
                      className="text-gray-800 mr-2"
                    >
                      <FacebookIcon fontSize="small" />
                    </a>
                  )}
                  {twitter_link && (
                    <a
                      target={"_blank"}
                      href={addProtocol(twitter_link)}
                      className="text-gray-800 mr-2"
                    >
                      <TwitterIcon fontSize="small" />
                    </a>
                  )}
                </SuiBox>
              </SuiBox>
            ) : (
              <SuiBox my={2} />
            )}
            <SuiBox mb={2} sx={{ textAlign: "start" }}>
              <SuiTypography
                variant="body1"
                color="text"
                fontWeight="bold"
                lineHeight={1.1}
                textTransform="uppercase"
                textAlign="start"
              >
                my website
              </SuiTypography>
              {storeData?.metadata?.company_link ? (
                <SuiBox sx={{ textAlign: "start" }}>
                  <SuiTypography
                    variant="body1"
                    color="text"
                    component={"a"}
                    href={addProtocol(storeData?.metadata?.company_link || "")}
                  >
                    {addProtocol(storeData?.metadata?.company_link || "")}
                  </SuiTypography>
                  <a
                    href=""
                    onClick={(e) => {
                      e.preventDefault();
                      navigator.clipboard.writeText(
                        addProtocol(storeData?.metadata?.company_link || "")
                      );
                    }}
                  >
                    <ContentCopyIcon sx={{ ml: 0.5 }} />
                  </a>
                </SuiBox>
              ) : (
                <SuiTypography
                  variant="body1"
                  color="text"
                  component={Link}
                  to={`/wall/portfolio/` + userData?.id}
                >
                  {document.location.host + `/wall/portfolio/` + userData?.id}
                </SuiTypography>
              )}
            </SuiBox>
            <SuiBox mb={2}>
              <SuiTypography
                variant="body1"
                color="text"
                fontWeight="bold"
                lineHeight={1.1}
                textTransform="uppercase"
                textAlign="start"
              >
                About
              </SuiTypography>
              <ReadMore
                limit={500}
                variant="body1"
                textTransform="none"
                color="text"
                textAlign="start"
              >
                {storeData.story}
              </ReadMore>
            </SuiBox>
          </SuiBox>
        </Card>
        <Card
          sx={{
            width: "100%",
            borderRadius: 0,
            mt: 1,
            textAlign: "center",
            minHeight: 140,
            pt: 4,
          }}
        >
          <SuiTypography
            variant="body1"
            color="text"
            fontWeight="bold"
            lineHeight={1.1}
            textTransform="uppercase"
          >
            upstyled member since:
          </SuiTypography>
          <SuiTypography variant="body1" color="text" lineHeight={1.4} sx={{ mt: 1 }}>
            {moment(userData?.created_at).format("MMM DD,YYYY")}
          </SuiTypography>
          {/* <SuiBox display="flex" justifyContent="center" alignItems="center">
              <SuiTypography
                variant="body1"
                color="text"
                lineHeight={1.4}
                sx={{ cursor: "pointer" }}
              >
                Report
              </SuiTypography>
              <SuiTypography variant="body1" color="text" lineHeight={1.4} sx={{ mx: 0.5 }}>
                |
              </SuiTypography>
              <SuiTypography
                variant="body1"
                color="text"
                lineHeight={1.4}
                sx={{ cursor: "pointer" }}
              >
                Block
              </SuiTypography>
            </SuiBox> */}
        </Card>
      </SuiBox>
      {chatVisible ? (
        <DraggableDialog
          heading={`Chat with ${userData?.stores?.[0]?.name || userData?.name}`}
          text={
            <SuiBox>
              <ChatRoom id={currentRoom?.id} />
            </SuiBox>
          }
          visible={chatVisible}
          hideAction={true}
          handleClose={() => {
            setChatVisible(false);
          }}
        />
      ) : null}
    </SuiBox>
  );
};

export default ProfileCardMobile;
